import { CustomDtcBagButton } from "@brandclub/common-ui";
import BagDrawer from "./BagDrawer";
import { useCartCount } from "@/api/cache/cartQueryOptions";

const BCBagButton = ({ mobile }: { mobile?: boolean }) => {
  const { data: cartCount } = useCartCount();

  const handleClick = () => {
    BagDrawer.show();
  };

  return <CustomDtcBagButton handleClick={handleClick} cartCount={cartCount} mobile={mobile} />;
};

export default BCBagButton;
